/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Select_PromptInputs */



/**
* | output |
* | --- |
* | "Please select a shortcut from the menu to start" |
*
* @param {Shortcut_Keys_Select_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_select_prompt = /** @type {((inputs?: Shortcut_Keys_Select_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Select_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez selectionner un raccourci dans le menu pour commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie im Menü eine Verknüpfung zum Starten aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una scorciatoia dal menu per iniziare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите ярлык из меню, чтобы начать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un acceso directo del menú para comenzar.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请从菜单中选择快捷方式开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するにはメニューからショートカットを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू करने के लिए कृपया मेनू से एक शॉर्टकट चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um atalho no menu para iniciar.")
	return /** @type {LocalizedString} */ ("Please select a shortcut from the menu to start")
});